import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why you should never write a book in .doc",
  "description": "",
  "published": "2013-09-12T00:00:00.000Z",
  "redirect_from": ["/blog/why-you-should-never-write-a-book-in-doc/swizec/6333"],
  "categories": "Writing",
  "hero": "./img/images-643.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "640px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/63169f99124663d1e07ccc5b27f6838e/c08c5/images-643.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "66.81614349775785%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'267\\'%20viewBox=\\'0%200%20400%20267\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M119%202v17l4%2014c2%206%204%2015%205%2027v6l-4-1c-26-2-46-2-46%201%200%200%2012%203%2019%203h4l-3%201H88c-6%200-11%201-9%202a326%20326%200%200046%205h2c0-1%201-1%201%201h1c0-2%202-3%202-1%200%203-2%204-4%204-2-1-2-1-1%201s1%202%202%201h1l1%201c2%200%204%203%206%209l5%2010c6%208%2010%2015%2010%2017l1%205%201%204h-20c-2%201-3%203-1%205v1c0%202-4%201-5%200%200-2-5-3-5-1l-2%201c-4%200-15%208-15%2011l-1%201c-2%200-2%201-2%204l-1%203-1-3-1-4c-2%200-3%202-1%202%201%201%200%207-1%207-2%200-3-2-2-3l1-2c0-2%200-2-3-2l-3%202-4%201-5%201-6%201-4%202-6%204c-5%203-6%203-3%205h8c0-2%208-4%2015-6%203%200%205%200%206%202l5%203c2%201%202%201%200%201-3%200-3%202%201%203%208%201%2010%202%2010%203l-2%201c-10%201-12%202-11%205s0%207-3%207c-4%200-3%202%201%203%205%201%2019%200%2020-2s2-16%201-17-2-7-1-8l1-5c0-7%202-9%2010-13l8-4h9l10%201v-4c0-9%202-5%202%204%201%2011%200%2030-1%2028s-1%200-1%205l-1%207-3%2010-2%203v1c2%200%201%203-1%205-1%201-3%204-3%208l-3%209c-4%206-5%2010-7%2018l-2%205c0-4%200-4-5-1-5%202-6%202-6-4-1-5-1-5-2-3s-1%201-1-5l1-9c1-1%202-4%201-16%200-7%200-8-2-8s-2%201-2%204%200%204%202%204l1%201-2%202c-2%200-5%207-4%208l-1%201c-2%200-2%202-1%204l2%206%202%2030h6l14%201%2013%202c7%200%2017%203%2024%206l14%205c8%202%207%202%2033-6l22-4a268%20268%200%200042-6l20-10c15-8%2025-11%2045-10l35%202h21v-33a4323%204323%200%20000-180V0H135l1%206-1%206c-2%200-3-3-3-6%201-6%200-6-6-6-5%200-7%200-7%202m35%2011l-1%208a408%20408%200%2001-1%2018c1%204%203%203%203-3l1-4v10l1%209%201-5%201-5v-2l-1-6-1-4v-4c1-1%200-10-1-10l-1-2h-1M2%2038c-2%201-1%206%201%206a824%20824%200%200083%204c7%200%2012-2%209-4l-9-1-11-2-29-1a192%20192%200%2001-44-2m2%2017l2%2013%2015%202h21c8%201%2010%200%205-2-2-2-2-2%200-2%204-2%200-8-5-7h-3c0-1-32-5-35-4m147%2016l-3%209c-2%206-3%207-5%207s-2%200-1%206c0%205%202%209%207%2019%201%203%205%204%205%202l1-2v-7l-1-7c-2%201-7-6-7-8l4-6c4-4%205-8%202-10l-1-2v-1h-1M1%20156c0%2032%200%2040%201%2039l7-4%207-5%2010-6%208-5h11l4-1c2-2-1-4-4-4h-2c-1-3-18-2-22%200-3%202-4%202-5%201l-4-1c-4%202-3-1%200-3%205-1%205-1%201-17-6-24-9-35-11-35l-1%2041m74-19c-2%202-2%202-3%201-2-2-9-2-10%200s-3%202-20%202H24l1%202%202%208%201%205h10l10-1h6c2%202%2017%200%2018-2%201-1%201-2-1-2-2-1-1-4%202-4%202-1%203%200%204%201%202%202%202%202%205%201l4-2c3%200%204-2%205-6%200-3%200-4-2-4l-2%201h-4c-2-3-6-2-8%200m259%2045l-4%201c-1%200%201%204%204%206%203%203%207%204%2012%202%203%200%203-1-1-6s-6-5-11-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/63169f99124663d1e07ccc5b27f6838e/ca0a1/images-643.webp 223w", "/static/63169f99124663d1e07ccc5b27f6838e/75680/images-643.webp 445w", "/static/63169f99124663d1e07ccc5b27f6838e/0ba47/images-643.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/63169f99124663d1e07ccc5b27f6838e/853b2/images-643.jpg 223w", "/static/63169f99124663d1e07ccc5b27f6838e/0a4fe/images-643.jpg 445w", "/static/63169f99124663d1e07ccc5b27f6838e/c08c5/images-643.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/63169f99124663d1e07ccc5b27f6838e/c08c5/images-643.jpg",
                "alt": "Writing photo by Chapendra",
                "title": "Writing photo by Chapendra",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Writing photo by Chapendra`}</figcaption>{`
  `}</figure></p>
    <p>{`Working with a publisher means you don't get full control. In fact you get surprisingly little control and everyone behaves like they know better than you about everything. Which they probably do.`}</p>
    <p>{`One thing you get no control over is the format you're going to write your book in. But hey, the publisher churns out a new book every week and they've been doing this for years. If somebody knows the best tools to write a book, it's going to be them.`}</p>
    <p>{`Naturally they ask you to write in `}<inlineCode parentName="p">{`.doc`}</inlineCode>{`. `}<a parentName="p" {...{
        "href": "http://office.microsoft.com/en-us/word/",
        "title": "Microsoft Word"
      }}>{`Word`}</a>{` gives you marvelous `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Diff",
        "title": "Diff"
      }}>{`diffing`}</a>{` features, there's comments, you can do styling and layouting, and it's perfect for having multiple people working on the same document simultaneously.`}</p>
    <p>{`Wait ... no it isn't. In fact Word `}<em parentName="p">{`sucks`}</em>{` at all of that!`}</p>
    <p>{`My heart sank the moment I opened `}<a parentName="p" {...{
        "href": "http://www.libreoffice.org",
        "title": "LibreOffice"
      }}>{`LibreOffice`}</a>{` to start working on `}<a parentName="p" {...{
        "href": "http://www.packtpub.com/data-visualization-with-d3js/book"
      }}>{`Data visualization with d3.js`}</a>{` way back in January.`}</p>
    <p>{`I can't use Word. Last I checked there still wasn't a linux version for my main computer and the pirated copy I have for my Mac crashes as soon as the software runs. Something about fonts.`}</p>
    <p>{`LibreOffice isn't bad per se, but there are `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/cool-thing-thursday-ia-writer/swizec/5517"
      }}>{`better`}</a>{` `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/how-draft-got-me-to-pay-for-a-free-product/swizec/6186"
      }}>{`writing tools`}</a>{` out there.`}</p>
    <p>{`Especially when it comes to code samples. Why am I dealing with code samples in .doc?`}</p>
    <p>{`But that's what the publisher wants. They even have a fancy base template with all of their custom styles that tell the layouting team what to do. I imagine they export into a better format and work from there.`}</p>
    <p>{`It's difficult to pinpoint why exactly working with this format has been so infuriating, but here are some issues I've run into:`}</p>
    <p>{`Because of collaboration you have to turn on `}<inlineCode parentName="p">{`record changes`}</inlineCode>{`. This lets the editors see what you've been up to. But it's slow without `}<inlineCode parentName="p">{`show changes`}</inlineCode>{`. Suddenly you're working with paragraphs that look like this:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/1ebf271e318deeb3e05c8eb9fdbfd852/93582/images-642.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.45739910313901%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'107\\'%20viewBox=\\'0%200%20400%20107\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M344%2020h-4l-4%201h-3c-1-1-5%200-6%201h-1v-2l-2%204v4h5c3%200%204%200%203-1v-1h6c4%200%206-2%204-3v-1l2%202%201%202%201-3c-1-3-1-5-2-3M21%2034l-1%202c0%202%203%203%204%202l-1-1-1-2c0-1%201-1%202%202%202%202%203%202%204%201h3l1-2%201-2v2l1%202%203%201%201-1h4v-1l-1-1c0-1%201-2%202-1l1%201c-1%201%201%203%202%202l1%201%201%202%201-4v-4h-9l-10%201h-9m295%200v4c3%201%206%200%206-2%201-2%201-2%201%200l2%202c3%201%204%200%204-2v-1l1%203c-1%203-1%204%202%201l6-1%203-1c0-3%202-2%202%200%201%202%203%202%204%200h-1l-2-1%202-1%201-1c0-2-12-1-12%201h-1c0-2-7-3-9-1h-1c0-2-4-1-4%201l-1%203v-3c0-2-2-3-3-1M20%2071c0%203%202%205%204%203h2l7%201c6%200%206%200%206-3l1-2v2c0%204%204%204%204%200s-2-4-2-1c-1%202-1%202-1%200s-1-2-7-2c-5%200-7%201-6%202h1l1%201-1%201-2-2-1-1-3-1c-3-3-3-3-3%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ebf271e318deeb3e05c8eb9fdbfd852/ca0a1/images-642.webp 223w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/75680/images-642.webp 445w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/8d1ba/images-642.webp 890w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/3838e/images-642.webp 1335w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/bc816/images-642.webp 1524w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/1ebf271e318deeb3e05c8eb9fdbfd852/e92b6/images-642.png 223w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/e66bf/images-642.png 445w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/4ef49/images-642.png 890w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/4e814/images-642.png 1335w", "/static/1ebf271e318deeb3e05c8eb9fdbfd852/93582/images-642.png 1524w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/1ebf271e318deeb3e05c8eb9fdbfd852/4ef49/images-642.png",
                "alt": "A 2nd draft paragraph",
                "title": "A 2nd draft paragraph",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`A 2nd draft paragraph`}</figcaption>{`
  `}</figure></p>
    <p>{`This makes it very easy to miss a space here and there or have too many full stops in a row.`}</p>
    <p>{`There's also a bug in Linux LibreOffice - not experienced by anyone else online as far as I can tell - that inserts a blank line after every paragraph with an edited last character. The new line is inserted every time you open the document.`}</p>
    <p>{`Which makes editors cross with you and question your sanity.`}</p>
    <p>{`And sometimes, randomly, when you change the styling of some text the styling would vanish somewhere between you and the editor.`}</p>
    <p>{`Oh and no matter what format you send the document in (I liked `}<inlineCode parentName="p">{`.odt`}</inlineCode>{` because it causes the least problems for LibreOffice) you will get it back as `}<inlineCode parentName="p">{`.docx`}</inlineCode>{`.`}</p>
    <p>{`A format LibreOffice's got `}<em parentName="p">{`catastrophic`}</em>{` problems with.`}</p>
    <p>{`Last week I was happily editing away, acting on the technical feedback I'd gotten, and after a few days I open the document ... it was 5 pages long. Not the 38 it was supposed to be. Five.`}</p>
    <p>{`Everything just up and vanished.`}</p>
    <p>{`But I'm using `}<a parentName="p" {...{
        "href": "http://www.dropbox.com",
        "title": "Dropbox"
      }}>{`Dropbox`}</a>{` so there's a backup every time I click Ctrl+S. I'm safe right?`}</p>
    <p>{`The last working version was 37. Out of 131. I was pretty mad.`}</p>
    <p><a parentName="p" {...{
        "href": "https://twitter.com/Swizec/statuses/375221837510492161"
      }}>{`https://twitter.com/Swizec/statuses/375221837510492161`}</a></p>
    <p>{`Some 15 pages of editing went `}<em parentName="p">{`poof`}</em>{`.`}</p>
    <p>{`It happened again a few days ago. But I was more careful and only lost 5 pages. Then I converted all current versions to `}<inlineCode parentName="p">{`.odt`}</inlineCode>{`. That seems to work.`}</p>
    <p>{`The collaboration has been wonderful too!`}</p>
    <p>{`Because we can't all work on the document at the same time, but have to resort to sending it around via email and working in sequence eeeeeverything draaaags oooout foreeever.`}</p>
    <p>{`Packt promised I had 3 months to write and then there'd be a 3 month editing process.`}</p>
    <p>{`We blew past that because I'm a slow writer, but in June I thought the book was done. We'd spent 3 months writing and 3 months editing.`}</p>
    <p>{`Then in the end of August I got technical feedback. Oh yeah.`}</p>
    <p>{`Yes editors are people too and they have other shit to do than care about my book and I'm really happy that one guy in particular (`}<a parentName="p" {...{
        "href": "https://twitter.com/kmrhb"
      }}>{`@kmrhb`}</a>{`) has taken great care to leave a comment next to almost every single paragraph ... but still.`}</p>
    <p>{`Apparently a big part of the main editor's job is merging all the documents everyone sends her.`}</p>
    <p>{`:`}{`|`}</p>
    <p>{`I'm not sure how that works, but a lot of the comments I got in late August are dated to early July. Hm.`}</p>
    <p>{`If you ever write a book, `}<em parentName="p">{`please`}</em>{` use a better tool. Write it in a textual format - markdown works well - and use something that shows diffs and helps you merge stuff and lets people comment without having to wait for you to finish.`}</p>
    <p>{`Draft looks like it's got a lot of those features. I've had great results with Github for my other book. `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/nightowls/pulls"
      }}><em parentName="a">{`Readers`}</em>{` have sent me typo fixes`}</a>{` that I can just merge!`}</p>
    <p>{`Whatever you do, don't write a book in .doc.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=f350f8fa-a9bf-4564-8a6f-07ec355d2aaa",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      